var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',[_c('img',{attrs:{"src":"/img/logo5-min.png","width":_vm.width,"alt":"Habeatat Logo","title":"Habeatat Logo"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }